module.exports = __webpack_public_path__ + "img/178.76e48649.jpg";